const ROLE = {
  DUPLICATE_TITLE: 'A role with the same title already exists.',
  CREATED: 'Role created successfully.',
  UPDATED: 'Role updated successfully.',
  DELETED: 'Role deleted successfully.',
  MISSING_TITLE: 'Role title is required.',
  NOT_FOUND: 'Role not found.',
  ERROR_DEFAULT_ROLE_UNSET: (role: string): string =>
    `Cannot unset the ${role} without setting another role as ${role} first`,
  ERROR_DEFAULT_ROLE_DELETE: (role: string): string =>
    `Cannot delete the ${role} role without setting another role as ${role} first`,
  ERROR_ASSIGNED_ROLE_DELETE:
    'Cannot delete role because it is assigned to existing users',
  REPLACEMENT_ROLE_NOT_FOUND: 'Replacement role not found',
  REPLACEMENT_ROLE_MUST_ACTIVE: 'Replacement role must be active.',
  REPLACEMENT_INVALID_DEPRECATED_ROLE:
    'Invalid replacement role, provided replacement role is in deprecated state',
  INVALID_DEPRECATED_ROLE: 'Invalid role, provided role is in deprecated state',
  ROLE_DELETE_REQUIRES_REPLACEMENT:
    'Cannot delete the role as it is assigned to users. Please provide a replacement role to proceed.',
  ROLE_ALREADY_ASSIGNED: 'Role already assigned to user.',
  USER_ROLE_NOT_ASSIGNED: 'Role is not assigned to the user.',
  USER_LAST_ROLE_REMOVAL:
    'You cannot remove the last role assigned to the user.',
  ASSIGNED: 'Role successfully assigned to user.',
  REMOVED: 'Role successfully removed from user.',
  ROLES_UPDATED: 'Roles updated successfully',
  SOME_ROLES_UPDATED_FAILED: 'Some roles failed to update',
  CANNOT_SET_DEPRECATED_AS_DEFAULT:
    'Cannot set a deprecated role as default for any user type',
  REPLACEMENT_ROLE_REQUIRED:
    'Replacement role id is required in case of deprecated state',
  PERMISSIONS_ASSIGNED: 'Permissions assigned to role successfully.',
  PERMISSIONS_REMOVED: 'Permissions removed from role successfully.',
  CANNOT_REMOVE_ALL_PERMISSIONS: 'Cannot remove all permissions from role.',
  NO_NEW_PERMISSIONS:
    'The requested permissions are already assigned to this role',
} as const;

export default ROLE;
